class ProjectFilter extends HTMLElement {
  #activeFilters = new Map([
    ['sector', 'todos'],
    ['marca', 'todos'],
    ['ubicacion', 'todos'],
  ]);

  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-filter-value]')];
    this.cards = [...this.querySelectorAll('[data-project-card]')];
    this.resultCount = this.querySelector('[data-result-count]');
    this.emptyState = this.querySelector('[data-empty-state]');

    for (const button of this.buttons) {
      button.addEventListener('click', this.#handleFilter);
    }

    this.#render();
  }

  disconnectedCallback() {
    for (const button of this.buttons ?? []) {
      button.removeEventListener('click', this.#handleFilter);
    }
  }

  #handleFilter = (event) => {
    const button = event.currentTarget;
    const group = button.closest('[data-filter-group]');
    const groupName = group?.dataset.filterGroup;

    if (!groupName) return;

    this.#activeFilters.set(groupName, button.dataset.filterValue);

    for (const candidate of group.querySelectorAll('[data-filter-value]')) {
      const isActive = candidate === button;
      candidate.setAttribute('aria-pressed', String(isActive));
      candidate.classList.toggle('filter-chip--active', isActive);
    }

    this.#render();
  };

  #render() {
    let visibleCount = 0;

    for (const card of this.cards) {
      const matches = [...this.#activeFilters.entries()].every(([group, value]) => {
        if (value === 'todos') return true;
        return (card.dataset[group] ?? '').split(' ').includes(value);
      });

      card.hidden = !matches;
      if (matches) visibleCount += 1;
    }

    if (this.resultCount) this.resultCount.textContent = String(visibleCount);
    if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
  }
}

if (!customElements.get('project-filter')) {
  customElements.define('project-filter', ProjectFilter);
}


(()=>{const page=document.querySelector('.case-series');if(!page)return;const video=page.querySelector('[data-series-video]');const play=video?.querySelector('[data-series-play]');if(play){play.hidden=false;play.addEventListener('click',()=>{const frame=document.createElement('iframe');frame.src=`https://player.vimeo.com/video/${video.dataset.videoId}?dnt=1&autoplay=0`;frame.title=video.dataset.videoTitle;frame.allow='fullscreen; picture-in-picture';frame.allowFullscreen=true;video.querySelector('img')?.remove();play.remove();video.prepend(frame);frame.focus();},{once:true});}const dialog=page.querySelector('.series-lightbox');const items=[...page.querySelectorAll('[data-gallery-item]')];let active=0,opener;const show=i=>{active=(i+items.length)%items.length;const source=items[active].querySelector('img');const image=dialog.querySelector('img');image.src=source.currentSrc||source.src;image.alt=source.alt;dialog.querySelector('[data-caption]').textContent=items[active].querySelector('figcaption').textContent;dialog.querySelector('[data-count]').textContent=`${active+1} / ${items.length}`;};if(dialog?.showModal){items.forEach((item,i)=>item.querySelector('button').addEventListener('click',e=>{opener=e.currentTarget;show(i);dialog.showModal();}));dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close());dialog.querySelector('[data-prev]').addEventListener('click',()=>show(active-1));dialog.querySelector('[data-next]').addEventListener('click',()=>show(active+1));dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')show(active-1);if(e.key==='ArrowRight')show(active+1);});dialog.addEventListener('close',()=>opener?.focus());}})();

(() => {
  const page = document.querySelector('.barrys-premium');
  if (!page) return;
  const video = page.querySelector('[data-barrys-video]');
  const playVideo = video?.querySelector('[data-video-play]');
  if (playVideo) {
    playVideo.hidden = false;
    playVideo.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      iframe.src = 'https://player.vimeo.com/video/1176667906?dnt=1&autoplay=0';
      iframe.title = 'Barry’s West Hollywood Ride Studio Facility Showcase — Life Fitness';
      iframe.allow = 'fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      video.querySelector('img').remove();
      playVideo.remove();
      video.prepend(iframe);
      iframe.focus();
    }, {once:true});
  }
  const dialog = page.querySelector('.barrys-lightbox');
  const photos = [...page.querySelectorAll('.gallery-card')];
  let activeIndex = 0;
  let opener;
  const showPhoto = index => {
    activeIndex = (index + photos.length) % photos.length;
    const source = photos[activeIndex].querySelector('img');
    const image = dialog.querySelector('img');
    image.src = source.currentSrc || source.src;
    image.alt = source.alt;
    dialog.querySelector('#barrys-photo-caption').textContent = photos[activeIndex].querySelector('figcaption').innerText.replace(/\s+/g, ' ').trim();
    dialog.querySelector('[data-photo-count]').textContent = `${activeIndex + 1} / ${photos.length}`;
  };
  if (dialog && typeof dialog.showModal === 'function') {
    photos.forEach((figure,index) => {
      const image = figure.querySelector('img');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'barrys-photo-button';
      button.setAttribute('aria-label', `Ampliar imagen ${index + 1}: ${image.alt}`);
      button.setAttribute('aria-haspopup','dialog');
      image.before(button);
      button.append(image);
      button.addEventListener('click', () => {
        opener = button;
        showPhoto(index);
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-photo-close]').addEventListener('click',() => dialog.close());
    dialog.querySelector('[data-photo-prev]').addEventListener('click',() => showPhoto(activeIndex - 1));
    dialog.querySelector('[data-photo-next]').addEventListener('click',() => showPhoto(activeIndex + 1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Tab') {
        const buttons = [...dialog.querySelectorAll('button')];
        const first = buttons[0];
        const last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        showPhoto(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('close',() => opener?.focus({preventScroll:true}));
  }
  // Reveal the mobile action only after the header has passed, and never alongside another CTA.
  const sticky = page.querySelector('.mobile-cta');
  const header = page.querySelector('.site-header');
  const inlineActions = [...page.querySelectorAll('main a[href="https://www.fitnessforlifemx.com/pages/contact-us"]')];
  if ('IntersectionObserver' in window && sticky) {
    const visible = new Set([header]);
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      }
      const shouldHide = visible.size > 0 || header.getBoundingClientRect().bottom > 0;
      // Do not discard keyboard focus when the viewport changes around the sticky action.
      if (document.activeElement !== sticky) sticky.hidden = shouldHide;
    },{threshold:0});
    [header,...inlineActions].forEach(element => observer.observe(element));
    sticky.addEventListener('blur',() => { sticky.hidden = visible.size > 0; });
  }
})();

// FFL portfolio: support page HTML sanitized by Shopify. 2026-10-06.
(() => {
  const init = () => {
    document.querySelectorAll('.ffl-projects-page').forEach(page => {
      if (page.dataset.fflFiltersReady || page.matches('project-filter') || page.querySelector('project-filter')) return;
      const cards = [...page.querySelectorAll('[data-project-card]')];
      const groups = [...page.querySelectorAll('.filter-group')];
      if (!cards.length || !groups.length) return;
      const normalize = text => text.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      const labels = { 'todos': 'todos', 'todas': 'todos', 'comercial': 'comercial', 'hotel': 'hotel', 'residencial': 'residencial', 'corporativo': 'corporativo', 'educacion': 'educacion', 'life fitness': 'life-fitness', 'hammer strength': 'hammer-strength', 'ee. uu.': 'estados-unidos', 'europa': 'europa', 'india': 'india', 'mexico': 'mexico' };
      const bindings = groups.map(group => {
        const legend = normalize(group.querySelector('legend')?.textContent || '');
        const key = legend.includes('sector') ? 'sector' : legend.includes('marca') ? 'marca' : legend.includes('ubicacion') || legend.includes('pais') ? 'ubicacion' : null;
        const buttons = [...group.querySelectorAll('button.filter-chip')];
        return { key, buttons, values: buttons.map(button => button.dataset.filterValue || labels[normalize(button.textContent)]) };
      });
      if (bindings.some(binding => !binding.key || !binding.buttons.length || binding.values.some(value => !value))) return;
      page.dataset.fflFiltersReady = 'true';
      const active = new Map(bindings.map(binding => [binding.key, 'todos']));
      const displays = new Map(cards.map(card => [card, [card.style.getPropertyValue('display'), card.style.getPropertyPriority('display')]]));
      const status = page.querySelector('.filter-bar__status');
      const count = status?.querySelector('strong');
      const empty = page.querySelector('.project-filter__empty');
      status?.setAttribute('aria-live', 'polite');
      status?.setAttribute('aria-atomic', 'true');
      const render = () => {
        let visible = 0;
        cards.forEach(card => {
          const match = [...active].every(([key, value]) => value === 'todos' || (card.dataset[key] || '').split(/\s+/).includes(value));
          card.hidden = !match;
          if (match) {
            const [value, priority] = displays.get(card);
            if (value) card.style.setProperty('display', value, priority); else card.style.removeProperty('display');
            visible++;
          } else card.style.setProperty('display', 'none', 'important');
        });
        if (count) count.textContent = String(visible);
        if (empty) {
          empty.hidden = visible !== 0;
          if (visible) empty.style.setProperty('display', 'none'); else empty.style.removeProperty('display');
        }
      };
      bindings.forEach(({ key, buttons, values }) => {
        const select = index => {
          active.set(key, values[index]);
          buttons.forEach((button, i) => {
            button.setAttribute('aria-pressed', String(i === index));
            button.classList.toggle('filter-chip--active', i === index);
          });
        };
        select(values.indexOf('todos'));
        buttons.forEach((button, index) => {
          button.type = 'button';
          button.addEventListener('click', event => { event.preventDefault(); select(index); render(); });
        });
      });
      render();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
